export default [
    {
        path: 'alba',
        name: 'Alba',
        redirect: "home",
    },
    {
        path: 'home',
        name: 'Accueil',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/Home.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'InventoryManagement',
        name: 'Gestions des stocks',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/InventoryManagement.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'MovementManagement',
        name: 'Gestion des mouvements',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/MovementManagement.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'PipelineManagement',
        name: 'Gestion des logés',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/PipelineManagement.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'EnteringMeters',
        name: 'Saisie des compteurs',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/EnteringMeters.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'ImportingFiles',
        name: 'Importation des fichiers',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/ImportingFiles.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'LogManagement',
        name: 'Gestion des logs',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/LogManagement.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'UserManagement',
        name: 'Gestion des utilisateurs',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/UserManagement.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'Initialization',
        name: 'Initialisation',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/Initialization.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'Parameters',
        name: 'Parameters',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/Parameters.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
]
